import { render } from "./BrandWorldPage.vue?vue&type=template&id=71543db0"
import script from "./BrandWorldPage.vue?vue&type=script&lang=js"
export * from "./BrandWorldPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__